import styled from 'styled-components'

import { TTheme } from '@types'

export type TBadgeVariant = TTheme['variables']['badgeColor'] | string

export const BadgeStyled = styled.div<{ variant: TBadgeVariant; textColor?: string }>`
    border-radius: 50px;
    background-color: ${properties => properties.variant};
    color: ${properties => properties.textColor || '#fff'};
    font-weight: 600;
    font-style: normal;
    font-size: 12px;
    letter-spacing: 0px;
    line-height: 1.2;
    text-align: left;
    padding: 5px 10px;
`
